import { useLazyQuery, useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'

import { ACCOMMODATIONS_QUERY } from '../../graphql/accommodation'
import { TENANTS_QUERY } from '../../graphql/tenant'
import { Accommodation, BulkIdCode } from '../../types/accommodation'
import { Tenant } from '../../types/tenants'
import ProviderFilters from './ProviderFilters'
import ProviderList from './ProviderList'

interface ProviderSectionProps {
  accommodationIdCodes: BulkIdCode[]
  setAccommodationIdCodes: React.Dispatch<React.SetStateAction<BulkIdCode[]>>
  setAccommodationNamesForTable: React.Dispatch<React.SetStateAction<string[]>>
  autoCompleteTenantValue: any
  setAutoCompleteTenantValue: React.Dispatch<any>
}

const ProviderSection: React.FC<ProviderSectionProps> = ({
  accommodationIdCodes,
  setAccommodationIdCodes,
  setAccommodationNamesForTable,
  autoCompleteTenantValue,
  setAutoCompleteTenantValue
}) => {
  const [accommodationList, setAccommodationList] = useState<Accommodation[]>(
    []
  )

  const [filteredAccommodationList, setFilteredAccommodationList] = useState<
    Accommodation[]
  >([])

  const { data: tenants, loading: loadingForTenant } = useQuery<{
    tenants: Tenant[]
  }>(TENANTS_QUERY, {
    notifyOnNetworkStatusChange: true
  })

  const [getAccommodations, { data: accommodations }] = useLazyQuery<{
    accommodations: Accommodation[]
  }>(ACCOMMODATIONS_QUERY, {
    notifyOnNetworkStatusChange: true
  })

  useEffect(() => {
    if (accommodations?.accommodations) {
      const tempAcc =
        accommodations.accommodations
          .filter(
            (acc) =>
              acc.basicDetails.accommodationID &&
              accommodationIdCodes.some(
                (item) => item.ID === acc.basicDetails.accommodationID
              )
          )
          .map((item) => item.basicDetails.name) || []

      setAccommodationNamesForTable(tempAcc)
    }
  }, [accommodationIdCodes, accommodations])

  useEffect(() => {
    if (autoCompleteTenantValue) {
      getAccommodations({
        variables: {
          tenantId: autoCompleteTenantValue.value
        }
      })
    }
  }, [autoCompleteTenantValue])

  return (
    <div>
      <ProviderFilters
        tenants={tenants?.tenants}
        accommodations={accommodations?.accommodations}
        loadingForTenant={loadingForTenant}
        autoCompleteTenantValue={autoCompleteTenantValue}
        setAutoCompleteTenantValue={setAutoCompleteTenantValue}
        accommodationList={accommodationList}
        setAccommodationList={setAccommodationList}
        setFilteredAccommodationList={setFilteredAccommodationList}
      />
      {!!autoCompleteTenantValue && (
        <ProviderList
          accommodationList={accommodationList}
          // setAccommodationIDs={setAccommodationIDs}
          setAccommodationIdCodes={setAccommodationIdCodes}
          setAccommodationList={setAccommodationList}
          filteredAccommodationList={filteredAccommodationList}
          setFilteredAccommodationList={setFilteredAccommodationList}
        />
      )}
    </div>
  )
}

export default ProviderSection
